import { WWW_AUDIENCE_FILTER } from '@pkg/config/sanity/audience';
import { pageFields } from '~/apis/sanity/queries/partials/pageFields';

export const pageById = groq`{
  "page": *[_id == $id && ${WWW_AUDIENCE_FILTER}][0] {
    ${pageFields}
  },
}`;
